/**
 * v7.72 — Progressão oficial do pedido no SERVIDOR (MongoDB via backend).
 * Cada mudança de status feita pela cozinha/entregador é reportada ao
 * backend (fire-and-forget, tolerante a offline) pra que o pedido avance
 * de 'preparing' até 'delivered' também no banco — não só no Dexie local.
 */
const API_URL = process.env.REACT_APP_BACKEND_URL;

export async function updateOrderStatusOnServer(order, status) {
  const mpPaymentId = order?.mpPaymentId;
  if (!API_URL || !mpPaymentId) return { ok: false, reason: 'no_identifier' };
  try {
    const resp = await fetch(`${API_URL}/api/orders/status`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mpPaymentId, status }),
    });
    return await resp.json();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`[ORDER SYNC] falha ao reportar status '${status}' ao servidor (segue offline):`, err?.message || err);
    return { ok: false, reason: 'network' };
  }
}

/**
 * v7.82 — Exclusão DEFINITIVA no servidor (Mongo). Fire-and-forget.
 */
export async function hardDeleteOrderOnServer(order) {
  const mpPaymentId = order?.mpPaymentId;
  if (!API_URL || !mpPaymentId) return { ok: false, reason: 'no_identifier' };
  try {
    const resp = await fetch(`${API_URL}/api/orders/hard-delete`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ mpPaymentId }),
    });
    return await resp.json();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn('[ORDER SYNC] falha no hard-delete server-side (segue offline):', err?.message || err);
    return { ok: false, reason: 'network' };
  }
}

/**
 * v8.07 — Ponte HTTP OPERACIONAL (padrão do pagamento). POST síncrono do
 * pedido COMPLETO a cada transição de status — HTTP puro, sem sockets.
 * Timeout 6s pra nunca prender a UI.
 */
export async function upsertDispatchOrder(order, status) {
  if (!API_URL || order?.id === undefined || order?.id === null) return { ok: false, reason: 'no_identifier' };
  const controller = new AbortController();
  const tm = setTimeout(() => controller.abort(), 6000);
  try {
    const resp = await fetch(`${API_URL}/api/orders/dispatch/upsert`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ order, status }),
      signal: controller.signal,
    });
    if (!resp.ok) return { ok: false, reason: `http_${resp.status}` };
    return await resp.json();
  } catch (err) {
    // eslint-disable-next-line no-console
    console.warn(`[DISPATCH] upsert '${status}' falhou (Firebase segue como via paralela):`, err?.message || err);
    return { ok: false, reason: 'network' };
  } finally {
    clearTimeout(tm);
  }
}

/**
 * v8.07 — Polling do entregador: pedidos ready/delivering direto do backend
 * por HTTP REST. Retorna array ou null em falha de rede.
 */
export async function fetchDispatchActive() {
  if (!API_URL) return null;
  const controller = new AbortController();
  const tm = setTimeout(() => controller.abort(), 6000);
  try {
    const resp = await fetch(`${API_URL}/api/orders/dispatch/active`, { cache: 'no-store', signal: controller.signal });
    if (!resp.ok) return null;
    const body = await resp.json();
    return Array.isArray(body.orders) ? body.orders : null;
  } catch {
    return null;
  } finally {
    clearTimeout(tm);
  }
}
